import { Box, Avatar, Typography, Skeleton, Stack, useTheme } from "@mui/material";
import { ElindusRedColors, shortenUsername, toLocaleString } from "../../scripts/utils";
import { useDevice } from "../../hooks/use_site";

const AVATAR_SIZE = 40;

export default function UserActivityItem({ activity, isLoading }) {
  const device = useDevice(activity?.device_id);

  return (
    <Box
      sx={{ width: "100%", alignItems: "center", display: "flex", textAlign: "left", borderRadius: "10px", padding: 1 }}
      disabled={isLoading}
    >
      {isLoading ? (
        <Skeleton variant="circular" width={AVATAR_SIZE} height={AVATAR_SIZE} />
      ) : (
        <Avatar sx={{ bgcolor: ElindusRedColors(activity?.modified_by_user) }}>
          {shortenUsername(activity?.modified_by_user)}
        </Avatar>
      )}

      <Stack sx={{ flexGrow: 1, marginLeft: 2 }}>
        <Typography variant="body2">{isLoading ? <Skeleton /> : activity.description}</Typography>
        <Typography variant="caption" color={"#aaa"} sx={{ textAlign: "left" }}>
          {isLoading ? (
            <Skeleton width="100px" />
          ) : (
            <>
              {device ? (
                <b style={{ color: "#2F4F4F" }}>
                  {device.name} {"\u2022"}
                </b>
              ) : null}{" "}
              {toLocaleString(activity.datetime)}
            </>
          )}
        </Typography>
      </Stack>
    </Box>
  );
}
